<template>
  <fragment>

    <div class="node-body" :class="nodeClasses" :style="{ order: (clusterIndex * 3) + 1}" :data-index="`${clusterIndex}`" :data-node="clusterSlug(clusterIndex)">
      <NodeHeader :slug="slug" :node="node" :cluster="cluster" :clusterIndex="clusterIndex" :focus="focus" :nodeHeading="nodeHeading"/>
      
      <!-- clusterIsExpanded(clusterIndex) node (hacky if for the moment :sorry:)-->
      <div class="wrap-article" :class="{'sample-only': isSample}">
        <div class="sample-modal" v-if="isSample">
          <El state="sign-up" v-if="cluster.card.show.signUp"/>
          <El state="go-pro" v-if="cluster.card.show.goPro"/>
        </div>
        <div class="sample-overlay" v-if="isSample"></div>
        <div class="content">

          <div v-if="isLoaded" class="expanded-cluster">
            <template v-for="(senx, i) in body()">
              
              <div v-if="senx.template && (senx.template == 'timeline')" :key="`p1:${i}`" class="timeline-container">
                <h4>The Timeline</h4>
                <ul class="timeline">
                  <li v-for="(item, ii) in senx.timeline" :key="`senx:${item.slug}:${ii}`" class="timeline-item">
                    <span class="timeline-item-part part-time">{{ item.timestamp | timeline }}</span>
                    <span class="timeline-item-part part-copy">{{ item.name }}.</span>
                  </li>
                </ul>
              </div>

              <template v-else-if="senx.copy">
                <h4 v-html="senx.subhead" v-if="senx.subhead" :key="`subhead:${i}`"></h4>
                <div v-if="senx.wrap == 'div'" v-html="senx.copy" class="inline-content md-wrap" v-on:click="handleClick" :key="`p2div:${i}`"></div>
                <p   v-else                    v-html="senx.copy" class="inline-content" v-on:click="handleClick" :key="`p2p:${i}`"></p>
              </template>

              <template v-else-if="senx.followups">
                <div :key="`followups:${i}`">
                  <h4 v-html="senx.subhead" v-if="senx.subhead"></h4>
                  <ul class="followups">
                    <router-link v-for="question in senx.followups" :key="question" :to="`/search?q=${question}&mode=suggested`" rel="nofollow,noindex">
                      <li class="followup-item">
                        {{ question }}
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.7489 6.36403C12.0837 6.0061 12.0837 5.42481 11.7489 5.06688L7.46292 0.485338C7.12808 0.127405 6.5843 0.127405 6.24946 0.485338C5.91462 0.843271 5.91462 1.42455 6.24946 1.78249L9.07551 4.80058H0.857191C0.383057 4.80058 0 5.21005 0 5.71689C0 6.22372 0.383057 6.6332 0.857191 6.6332H9.07283L6.25213 9.65129C5.91729 10.0092 5.91729 10.5905 6.25213 10.9484C6.58697 11.3064 7.13076 11.3064 7.4656 10.9484L11.7515 6.36689L11.7489 6.36403Z" fill="black"/>
                        </svg>
                      </li>
                    </router-link>
                  </ul>
                </div>                
                <p class="inline-content" v-on:click="handleClick" :key="`p2:${i}`"></p>
              </template>

              <!-- <div v-else-if="senx.banner" class="cluster-cta" :key="`banner:${i}`">
                <BannerCTA state="sign-up"/>
              </div> -->

              <!-- Demo: Cluster Image -->
              <!-- <div class="cluster-image" v-if="(!((i+3) % 5) || ((body().length <= 3) && ((i+1) == body().length))) && senx.image && senx.photo" :key="`img:${i}`"> -->
              
              <!-- <div class="banner-wrapper" v-if="(i == 0) && senx.image && senx.photo" :key="`pre-img-banner:${i}`">
                <BannerCTA state="sign-up" v-if="isGuest"/>
                <BannerCTA state="go-pro" v-if="isFree"/>
              </div> -->
              
              <div class="cluster-image" v-if="(i == 0) && senx.image && senx.photo" :key="`img:${i}`">
                <img :src="senx.image" :alt="senx.synopsis"/>
              </div>

              <div class="cluster-image-caption" v-if="(i == 0) && senx.image && senx.photo" :key="`img-caption:${i}`">
                <div class="caption" v-html="senx.caption"></div>
              </div>

            </template>
            
            <!-- <p class="inline-content go-pro-wrap" v-if="!isSignedIn">
              This general summary was written by our NewsAI for everyone. 
              Sign up and Go Pro and let our AI write just for you, taking into account what you already know to balance your news diet.
            </p> -->

            <!-- <p class="inline-content go-pro-wrap" v-if="isSignedIn && !isPro">
              This general summary was written by our NewsAI for everyone.
              <a href="javascript:void(0)" @click="goPro">Go Pro today</a> and let our AI write just for you, 
              taking into account what you already know to balance your news diet.
            </p> -->

            <!-- <div v-if="isGuest">
              <BannerCTA state="sign-up"/>
            </div>
            <div v-if="isFree">
              <BannerCTA state="go-pro"/>
            </div> -->

          </div>

          <Loading v-else-if="!isLoaded" reckoner="story" :reckoner-data="getReckonerData"/>
        
        </div>
      </div>
    </div>
  </fragment>    
</template>

<script>
  import API from 'app/axios';
  import utils from '@assets/js/utils.js';
  import layout from '@assets/js/layout.js';
  import story from '@assets/js/news/story-utils.js';
  import { Fragment } from 'vue-fragment';
  // import Sub from 'app/components/_v3.3/news/story/Sub';
  import NodeHeader from 'app/components/_v3.3/news/story/Body/NodeHeader.vue';
  import El from '@/components/_v5/cta/El.vue';
  // import BannerCTA from 'app/components/_v6/cta/BannerCTA.vue';

  export default {
    mixins: [story, utils, layout],
    components: {
      Fragment,
      // Sub,
      NodeHeader,
      El,
      // BannerCTA,
    },
    props: {
      slug: String,
      node: String,
      cluster: Object,
      clusterIndex: Number,
      focus: Boolean,
    },
    data() {
      return {
        isProTestState: false,
        loadIssued: false,
        hasFocused: false,
        hasLoaded: false,
        templates: {
          attr: {
            _default: () => `${this.p.sSenX}.`,
            first: {
              pool: () => `${this.p.sSenX}, according to ${this.p.sPubMark}.`,
              assumed: () => `${this.p.sSenX}, writes ${this.p.oAuthor.fname} ${this.p.oAuthor.sname} for ${this.p.sPubMark}.`,
              individual: () => `${this.p.sSenX}, writes ${this.p.oAuthor.fname} ${this.p.oAuthor.sname} for ${this.p.sPubMark}.`,
            },
            nth: {
              pool: () => `According to ${this.p.sPubMark}, ${this.p.sSenX}.`,
              assumed: () => `Writing for ${this.p.sPubMark}, ${this.p.oAuthor.fname} ${this.p.oAuthor.sname} said ${this.p.sSenX}.`,
              individual: () => `Writing for ${this.p.sPubMark}, ${this.p.oAuthor.fname} ${this.p.oAuthor.sname} said ${this.p.sSenX}.`,
            },
          }
        },
        p: {}, // legacy (early proto) for storing compiled content derived from the API data.. 
      }
    },
    computed: {
      isAlpha() {
        return this.$store.getters.isAlpha;
      },
      nodeDetail() {
        return this.$dataEngine.clusterGet(this.clusterIndex);
      },
      nodeContent() {
        if (!this.node) {
          return false;
        }
        // console.log(`DEPRECATED:: Node: Getting nodeContent (${this.clusterNode}) -- `, this.$store.getters.getStoryNodeV3(this.clusterNode));
        return this.$store.getters.getStoryNodeV3(this.clusterNode);
      },
      nodeHeading() {
        return this.nodeContent?.synthetic?.cache?.name || '...'; // this.clusterHeadline(this.clusterIndex);
      },
      clusterNode() {
        return this.cluster?.links?.[0];
      },
      isFocused() {
        return this.focus;
      },
      isLoaded() {
        return this.nodeContent !== false;
      },
      isSample() {
        if (this.cluster.card.show.signUp || this.cluster.card.show.goPro) {
          return true;
        }
        return false;
      },
      
      nodeClasses() {
        let classes = '';
        if (this.hasFocused) { classes += 'has-appeared '; }
        if (this.isLoaded) { classes += 'has-loaded '; }
        classes += `read-state-${this.clusterReadState(this.clusterIndex).code}`;
        return classes;
      },

      getReckonerData() {
        return {
          topic: this.clusterTopics(this.clusterIndex)?.filter(a => a.meta_wiki).map(a => a.topic_name), // { return {...a}; }),
          publisher: this.clusterPublishers(this.clusterIndex)?.map(a => a.name),
        };
      },

    },
    methods: {
      body() {
        // console.log('Using modified body-synth...');
        // console.log('NODE', this.$dataEngine.v3_buildSynthBody(this.slug, this.clusterNode))
        return this.$dataEngine.v3_buildSynthBody(this.slug, this.clusterNode);
      },
      load() {
        // console.log(`Node: Loading!`);
        API.getStoryNodeV3(this.slug, this.clusterNode);
      },
      handleClick(e) {
        let data = e.target?.dataset || {};
        let ele = e.target;
        let payload = {};

        switch (data.click) {
          case 'report':
            ele.classList.add('working');
            API.postReportArticle({
              type: data.type,
              story: this.slug,
              article: data.article,
            }).then(() => {
              ele.classList.remove('working');
              ele.classList.add('done');
            });
            break;
          case 'outclick':
            payload = {
              src: this,
              article: this.getArticle(data.article),
              story: this.getStory(this.slug) || '-',
            };
            this.EventBus.$emit("didSelectArticle", payload);
            break;
        }
      },

      hasRead(code) {
        if (code && (code != 'updated')) { return true; }
        return false;
      },

      getReadStateColor(code) {
        switch (code) {
          case 'preview': return '#6D7479'
          case 'glanced': return '#6D7479'
          case 'skimmed': return '#6D7479'
          case 'read': return '#14B31F'
        }
      },

      getReadStateIcon(code) {
        if (code) {
          if (code === 'skimmed' || code === 'read') {
            return 'double-tick'
          }

          return 'single-tick'
        }
      },

      goPro() {
        this.EventBus.$emit("didSelectSubscribe", {
          didSelect: 'true' 
        });
      },
    },
    mounted() {
      // console.warn(`Node: MOUNTED`, this.focus, this.slug, this.node, this.clusterIndex, this.$dataEngine.clusterGet(this.clusterIndex)?.links);
      if (this.focus) {
        // console.log(`Node: Mounted in focus; loading...`);
        this.hasFocused = true;
        this.load();
      }
    },
    watch: {
      focus(to) {
        // console.log(`Node: Focus - Coming into focus..`);
        if (!to) {
          // console.log(`Node: Focus (Ignoring; this is a blur (${to}))`);
        }
        if (this.loadIssued) {
          // console.log(`Node: Focus (Ignoring; load already issued)`);
        }
        if (this.nodeContent) {
          // console.log(`Node: Focus (Ignoring; content already loaded)`);
        }
        // console.log(`Node: Focus - Hitting API, because we have nothing!.. `);
        this.hasFocused = true;
        this.load();
      }
    }
  }
</script>
<style lang="scss">
  body:not([data-scrollsnap]) {
    .primary-cluster {
      min-height: initial;
      padding-bottom: initial;

      @media (max-width: 785px) {
        min-height: initial;
      }
    }
    .wrap-article:not(.sample-only) {
      // padding-bottom: 25vh;
      min-height: 50vh;
    }
  }
</style>
<style lang="scss" scoped>
  @import 'src/assets/scss/__2020_v3.scss';


  .timeline {
    margin-left: 2em;
    .timeline-item {
      display: grid;
      grid-template-columns: 100px 1fr;
      margin-bottom: .5em;
      grid-gap: 1em;

      .timeline-item-part {
        &.part-time {
          font-weight: bold;
        }
      }
    }

    margin-bottom: 2em;
  }

  .followups {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;

    @media (max-width: 850px) {
      padding: 0 0.75rem;
    }

    .followup-item {
      font-size: 0.9rem;
      position: relative;
      background: rgba($neutral-400, 0.1);
      border-radius: 10px;
      padding: 1rem;
      transition: all 0.2s ease-in-out;

      svg {
        margin-left: 1rem;
        padding-top: 1px;

        @media (max-width: 850px) {
          margin-left: 0.25rem;
        }

        path {
          fill: $neutral-100;

          .darkmode & {
            fill: $neutral-600;
          }
        }
      }

      &:hover {
        background: $yellow-tone-3;
        color: $neutral-100;

        svg path {
          fill: $neutral-100;
        }
      }
    }
  }

  .node-meta {
    grid-column: span 1;

    .inner-node-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // height: 80vh; // Should be more dynamic. To be fixed.
      // .desktop & {
      //   @include sticky-meta;
      // }

      // version-5 modal
      .context-v5 & {
        top: 1em;
      }

      .mobile & {
        // padding: 0 0.8em;
        display: none;
      }
    }
  }

  // play in styling.. 
  .node-header-wrapper {
    // opacity: 0.5;
    transition: opacity .3s .6s ease-in-out;
    .has-appeared & {
      opacity: 1;
    }
  }
  
  .wrap-article {
    opacity: 0.5;
    transition: opacity .3s .6s ease-in-out;
    // border-bottom: 1px solid rgba($neutral-400, 0.2);

    .has-appeared & {
      opacity: .5;
    }
    .has-loaded & {
      opacity: 1;
    }
  }

  // .node-body::before {
  //   content: '';
  //   position: absolute;
  //   top: 0.70rem;
  //   display: inline-block;
  //   width: 0.5rem;
  //   height: 0.5rem;
  //   border-radius: 50%;
  //   margin-left: -1.2rem;
  //   background: $neutral-400;

  //   .mq-sm & {
  //     margin-left: -0.15rem;
  //   }
  // }

  // .read-state-read::before {
  //   background: $green-tone-3;
  // }

  // .read-state-skimmed::before {
  //   background: $orange-tone-3;
  // }

  // .read-state-glanced::before {
  //   background: $red-tone-3;
  // }

  .node-body {
    position: relative;
    grid-column: span 1;
    // border: 1px dotted blue;
    // min-height: 80vh;
    padding: 2.5rem 2rem 7rem 2rem;

    // margin-bottom: 2em;
    // margin-top: 2em;
    // padding-left: 2rem;

    &[data-index="0"] {
      margin-top: 0;
    }

    @media (max-width: 850px) {
      padding: 2rem 1rem 6.5rem 1rem;
    }

    &:not(:first-child) {
      border-top: 1px solid rgba($neutral-400, 0.25);
    }

    // .context-v5 & {
    //   .desktop & {
    //     grid-column: span 2;
    //   }
    // }
  }

  .sample-only {
    display: flex;
    justify-content: center;
    position: relative;
    height: 25rem;
    overflow: hidden;
    opacity: 0.5;

    .sample-modal {
      z-index: 20;
      position: absolute;
      margin-top: 4rem;
      width: 80%;
    }

    .sample-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      // filter: blur(10px);
      background: linear-gradient(rgba($neutral-600, 0.95),rgba($neutral-600, 1));
      z-index: 10;

      .darkmode & {
        background: linear-gradient(rgba($neutral-100, 0.95),rgba($neutral-100, 1));
      }
    }
  }

  // &.context-v5 {
  //   .node-body {
      
  //   }
  // }

  .up-next-locked {
    opacity: 0.3;
  }

  .up-next {
    h3 {
      @include typo-size-small-heading;
    }
  }

  .up-next-events {

    .inner-event {
      display: flex;
      align-items: center;
      padding: 0.5rem;
      background: $neutral-600;

      &:not(:last-child) {
        margin-bottom: 0.8rem;
      }

      .image {
        width: 40px;
        height: 40px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        margin-left: 0.8em;
        flex: 1;

        h2 {
          @include typo-size-small-heading;
          @include limit-1-line;
          margin: 0;
          margin-bottom: 0.2rem;
        }

        p {
          @include typo-size-body-small;
          @include limit-2-lines;
          margin: 0;
        }
      }
    }
  }

  .section-sign-up,
  .section-go-pro {
    border-radius: $el-border-radius;
    margin-top: 1em;
    cursor: pointer;

    .inner-section-content {
      display: flex;
      align-items: center;
      padding: 1.2em 1em;

      .inner-content {
        @include typo-size-body-small;
        flex: 1;
        margin: auto 1em auto auto;

        p {
          margin: 0;
        }

        .callout {
          display: inline;
          font-weight: bold
        }
      }

      button {
        @include base-btn;
      }
    } 
  }
  
  .section-sign-up {
    .inner-section-content {
      background: $yellow-tone-3;

      button {
        background: $white-primary;
      }
    }
  }

  .section-go-pro {
    .inner-section-content {
      background: $green-tone-3;

      .inner-content {
        color: $white-primary;
      }

      button {
        background: $green-tone-4;
        color: $white-primary;
      }
    }
  }



  // Node Meta - To be included in component once built
  .statements {
    margin: 0.8em 0;

    &:only-child {
      margin-bottom: 0;
    }

    .statement {
      border-left: 3px solid $yellow-tone-3;
      padding-left: 0.8em;

      h3 {
        @include typo-size-body;
        margin-top: 0;
        margin-bottom: 0;
        font-size: 12px;
        line-height: 1.4;
      }
      
      &:not(:last-child) {
        margin-bottom: 1em;
      }

      .byline {
        display: inline-block;
        @include typo-size-small;
        margin-bottom: 0.7em;
        margin-top: 0;
      }
    }
  }

  .tags {
    display: flex;
    flex-direction: column;
    // display: -webkit-box;
    // overflow-x: scroll;
    // overflow-y: hidden;
    // -ms-overflow-style: none;  /* IE and Edge */
    // scrollbar-width: none;  /* Firefox */
    margin: 2em 0;

    .mobile & {
      margin: 2em 0 0 0;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .tag {
      cursor: pointer;
      // margin-right: 1em;
      margin-bottom: 0.8em;
    }

    // .tag:not(:last-child) {
    //   margin-right: 1em;
    // }
  }

  .publisher-meta {
    display: flex;
    align-items: center;
    @include typo-size-small-heading;
    margin-bottom: 2em;

    .mobile & {
      margin-bottom: 0;
    }

    .publishers {
      display: flex;
      margin-right: 0.8rem;

      .publisher {
        width: 30px;
        height: 30px;

        &:not(:first-child) {
          margin-left: -12px;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          border: 2px solid white;
        }
      }
    }
  }

  .publishers {
    display: flex;
    align-items: center;
    margin-top: 1em;

    &:not(:last-child) {
      margin-right: 0.7em;
    }

    .inner-image {
      width: 38px;
      height: 38px;
      
      &:not(:first-child) {
        margin-left: -0.8em;
      }

      .mobile & {
        width: 32px;
        height: 32px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
        border: 1px solid $neutral-500;
      }
    }

    .tag:not(:last-child) {
      margin-right: 0.3em;
    }
  }







  .meta-read-state {
    display: flex;
  }

  .meta-tags {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0.6em;
  }

  .updated-read-state {
      @include typo-size-body-small;
      display: flex;
      align-items: center;
      justify-content: center;
      background: $green-tone-1;
      color: $green-tone-4;
      font-size: 0.6em;
      padding: 0.5em;
      margin-bottom: 1em;

      .callout {
        font-weight: bold;
      }
    }

    .read-state-group {
      display: flex;
      flex-direction: column;

      .mobile & {
        flex-direction: row;
        display: -webkit-box;
        overflow-x: scroll;
        overflow-y: hidden;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }

      .inner-read-group {
        display: flex;
        flex-direction: column;

        .mobile & {
          flex-direction: row-reverse;
          justify-content: flex-end;
        } 
      }
    }

    .read-status {
      display: flex;
      align-items: center;
      @include typo-size-small;
      margin-right: 1em;

      .mobile & {
        margin-left: 0.8em;
      }

      .icon {
        margin-right: 0.8em;
      }

      &.read-state-preview {
        color: $neutral-400;
      }

      &.read-state-glanced {
        color: $red-tone-3;
      }

      &.read-state-skimmed {
        color: $orange-tone-3;
      }

      &.read-state-read {
        color: $green-tone-3;
      }
    }

  .base-tag {
    @include base-tag;
    // position: sticky;
    top: $iHeadHeightCollapsed + ($iGap);
    z-index: 1;
    margin: 1em 0;
    color: $yellow-tone-7;

    ::before {
      content: '';
      // position: absolute;
      // background: $cBackground;
      height: $iGap;
      left: 0;
      right: 0;
    }

    &:not(:last-child) {
      margin-right: 0.5em;
    }
  }

  .primary-cluster {
    padding-top: 1em;

    // MUST MATCH: real elements v faux elements
    min-height: 100vh;
    // padding-bottom: 25vh;

    @media (max-width: 785px) {
      min-height: 200vh;
    }

    .mobile & {
      border-top: 1px solid $neutral-450;
      border-bottom: 1px solid $neutral-450;

      &:first-child {
        border-top: unset;
      }

      &:last-child {
        border-bottom: unset;
      }
    }
  }
  
  .cluster-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .mobile & {
      padding: 0 0.8em;
    }


    .wrap-meta {
      display: flex;
      
      .image {
        width: 65px;
        height: 65px;
        cursor: pointer;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .content {
        flex: 1;
        margin-right: 1em;
        cursor: pointer;

        h2 {
          @include typo-size-headline;
          margin-bottom: 0.4em;
        }

        p {
          @include typo-size-body;
          font-size: 16px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .tags {
          display: flex;
          margin-top: 1em;

          .tag {
            cursor: pointer;
          }

          .tag:not(:last-child) {
            margin-right: 1em;
          }
        }

        // expanded/collapsed model removed (and not transferred into this component)
        // &.expanded {
        //   h2 {
        //     margin-bottom: 1em;
        //   }
        // }
      }
    }

  }

  .wrap-article {
    // border: 1px solid red;

    // IMPORTANT - influences the snap sensitivity.. 
    // padding-bottom: 50vh;
  }

  h4 {
    font-size: 1.1rem;
    font-family: 'Circular';
    line-height: 1.8em;
    margin-bottom: 1em;
    font-weight: bold;
    display: inline-block;
    // padding: 0 1em;
    .mobile & {
      margin: 0 0 1em 0.8em;
    }
  }

  .inline-content {
    @include typo-size-body;
    font-size: 1.1rem;
    line-height: 1.8em;
    font-family: "Colfax";

    .mobile & {
      padding: 0 0.8em;
    }

    &:not(:last-child) {
      margin-bottom: 2rem;
    }

    &.go-pro-wrap {
      // font-style: italic;
      a {
        color: $green-tone-3;
        font-weight: bold;
      }
    }

    // specifically markdown insertion (need specific tlc)
    &.md-wrap {
      ::v-deep { // break css scoping for interploated content
        ul {
          margin-left: 1em;
          margin-bottom: 1em;
          li {
            padding-left: .5em;
            
            &:not(:last-child) {
              margin-bottom: 0.5rem;
            }

            &::before {
              content: url('~@assets/images/inline-arrow.svg'); 
              color: $yellow-tone-3;
              display: inline-block; 
              width: 1.25em;
              margin-left: -1.25em;
            }
          }
        }
        p {
          margin-bottom: .5em;
          font-size: 1.1rem;
          line-height: 1.8em;
        }
      }
    }

    ::v-deep { // break css scoping for interploated content
      .intro {
        font-size: 1.1em;
        background: rgba($yellow-tone-3, 0.5);
        border-radius: 5px;
        padding: 0.5em;
      }
      .pub-mark {
        white-space: nowrap;
        
        // no need for the outer span?
        img {
          // ems, because should match to whatever font
          width: 1em;
          height: 1em;
          object-fit: cover;
          border-radius: 50%;
          // better font/baseline placement
          position: relative;
          top: 2px;
          // diminish
          // transition: all 1s;
          // transition-delay: 1s;
          // filter: grayscale(100%) opacity(0) blur(2px);
        }
        a {
          border-bottom: 2px solid $yellow-tone-3;
          cursor: pointer;
        }
        // &:hover {
        //   img {
        //     filter: none;
        //     transition-delay: 0s;
        //     transition: all .3s;
        //   }
        // }
      }
      .pub-errors {
        font-size: 0.5em;
        position: relative;
        // top: -11px;
        font-family: 'Circular';
        color: #888;
        cursor: pointer;
        .working {
          color: $orange-tone-3;
        }
        .done {
          color: $green-tone-3;
        }
      }

    }
  }

  .banner-wrapper {
    margin-bottom: -1em;
    margin: 1rem 0 0.8rem 0;
  }

  .cluster-image-caption {
    // text-align: right;
    margin-bottom: 2.5em;
    margin-top: 0.5rem;
    // color: $neutral-400;
    // font-size: 0.75rem;

    font-size: 0.8rem;
    border-left: 1px solid $neutral-400;
    padding: 0.25rem 0.75rem;
    margin-top: 0.5rem;
    max-width: 600px;
  }

  // Article blocks
  .cluster-image {
    height: 400px;
    position: relative;

    margin-top: 2em;

    border-radius: $el-border-radius;
    overflow: hidden;

    .mobile & {
      height: 250px;
      // padding-left: 0.8em;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }

    .caption {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0,0,0,.8);
      backdrop-filter: blur(3px);
      padding: 1.5em;
      // @include typo-size-small;
      color: $white-primary;
      text-align: right;
      ::v-deep .photo-credit {
        white-space: nowrap;
        color: $neutral-400;
      }
    }
  }

  .cluster-tweet {
    display: flex;
    align-items: center;

    .content {
      display: flex;
      flex-direction: column;
      margin: 1.5em 0 1.5em 1.5em;
      padding: 1.2em;

      .tweet-profile {
        display: flex;

        .tweet-profile-image {
          width: 30px;
          height: 30px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            border-radius: 50%;
          }
        }

        .tweet-profile-meta {
          display: flex;
          flex-direction: column;
          margin-left: 0.5em;

          h5 {
            @include typo-size-small-heading;
            margin: 0;
          }

          p {
            @include typo-size-body-small;
            margin: 0;
          }
        }
      }

      .tweet-content {
        p {
          @include typo-size-body;
        }
      }
    }
  }
</style>